<mat-card
  class="catalog-card"
  [class]="{
    'catalog-card--not-assigned': isCatalogNotAssigned(),
    'catalog-card--active': isCatalogActive(),
  }"
>
  <div class="card-header">
    <div class="card-header__main">
      <div class="card-header__info-row">
        <mp-catalog-param [title]="'Katalog:'" [value]="catalog().name" />

        <mp-catalog-param [title]="'Quelle:'" [value]="catalog().dataSource" />
      </div>

      <ng-content select="[catalog-card-main-content]" />
    </div>

    <div class="card-header__aside">
      <mp-catalog-param
        [title]="'Letzter Import'"
        [value]="(catalog().lastStaging | humanizeRelativeDate: { whenInRange: { days: 2 } }) ?? ''"
      />
    </div>
  </div>

  <mp-catalog-card-footer
    [catalogData]="catalog()"
    [showAdditionalInfo]="showAdditionalInfo()"
    [openTaskIconMap]="openTaskIconMap()"
    (catalogDetailsClick)="catalogDetailsClick.emit($event)"
  >
    <ng-container ngProjectAs="[catalog-card-footer-actions]">
      <ng-content select="[catalog-card-footer-actions]" />
    </ng-container>
  </mp-catalog-card-footer>
</mat-card>
